import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;

export const adminApi = axios.create({ baseURL: ADMIN_API });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("empco_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("empco_admin_token");
      localStorage.removeItem("empco_admin_user");
      if (window.location.pathname.startsWith("/admin") && !window.location.pathname.startsWith("/admin/login") && !window.location.pathname.startsWith("/admin/reset") && !window.location.pathname.startsWith("/admin/forgot")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);
